import { render, staticRenderFns } from "./StackedOverlay.vue?vue&type=template&id=4a2a9126&scoped=true&lang=html&"
import script from "./StackedOverlay.vue?vue&type=script&lang=js&"
export * from "./StackedOverlay.vue?vue&type=script&lang=js&"
import style0 from "./StackedOverlay.vue?vue&type=style&index=0&id=4a2a9126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2a9126",
  null
  
)

export default component.exports